import React from "react";
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import SignIn from "./SignIn";
import { useRouter } from "./../util/router.js";

function SignInSection(props) {
  const router = useRouter();

  // Go to page after signin
  const onSignin = () => {
    if (props.disableAfterAuth) {
      return
    }
    if (props.afterAuthUrl) {
      router.replace(props.afterAuthUrl)
    } else if (props.afterAuthPath) {
      router.push(props.afterAuthPath)
    } else {
      router.push("/dashboard");
    }
  };

  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container
        style={{
          maxWidth: "850px"
        }}
      >
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        ></SectionHeader>
        <SignIn
          buttonText={props.buttonText}
          inputSize={props.inputSize}
          onSignin={onSignin}
        ></SignIn>
      </Container>
    </Section>
  );
}

export default SignInSection;
